import type { Field, OnFinishReturnObject } from '@evidia/components';
import { SimpleForm } from '@evidia/components';
import type { StudentDefaultTeacherType } from '@evidia/shared';
import { useActiveSchoolId } from '../hooks/useActiveSchoolId';
import type { RouterOutput } from '../utils/trcp';
import { trpc } from '../utils/trcp';

export type DefaultTeacherType = RouterOutput['studentDefaultTeacher']['getDefaultTeacher'];

interface Props {
	studentId: string;
	type: StudentDefaultTeacherType;
	defaultTeacher?: DefaultTeacherType;
	refetch: () => Promise<void>;
}

const DefaultTeacher: React.FC<Props> = ({ refetch, defaultTeacher, studentId, type }) => {
	const { activeSchoolId } = useActiveSchoolId();
	const getSchoolTeachers = trpc.school.getSchoolTeachers.useQuery({ schoolId: activeSchoolId });

	const setDefaultTeacher = trpc.studentDefaultTeacher.setDefaultTeacher.useMutation();

	const onFormFinish = async (values: { teacher: string }): Promise<OnFinishReturnObject> => {
		await setDefaultTeacher.mutateAsync({
			studentId,
			userId: values.teacher,
			type,
			schoolId: activeSchoolId,
		});
		await refetch();
		return {
			status: 'success',
			title: 'Uloženo',
			subtitle: 'Výchozí učitel byl nastaven',
		};
	};

	const teachers =
		getSchoolTeachers.data?.map(teacher => ({
			key: teacher.id,
			value: `${teacher.firstName} ${teacher.lastName}`,
		})) || [];

	const field: Field[] = [
		{
			key: 'teacher',
			required: true,
			label: 'Výchozí učitel',
			type: 'select',
			loading: getSchoolTeachers.isLoading,
			values: teachers,
		},
	];

	return (
		<div>
			<SimpleForm
				disableSubmitButtonMargin
				lessSpaceBetweenItems
				fields={field}
				onFinish={onFormFinish}
				initialValues={{
					teacher: defaultTeacher?.id,
				}}
				loading={!defaultTeacher || getSchoolTeachers.isLoading}
				submitButtonTitle="Nastavit učitele"
				allowFinishFunctionLoading
			/>
		</div>
	);
};

export default DefaultTeacher;
